// extracted by mini-css-extract-plugin
module.exports = {"list_table":"styles_list_table__1ORBE","actions_icons":"styles_actions_icons__F07tS"};